import __request__ from "routing/request";
export function create(request) {
  return __request__("POST", "/system/indices/index_sets/templates", request, {}, {
    "Accept": ["application/json"]
  });
}
export function builtIns(warm_tier_enabled) {
  return __request__("GET", "/system/indices/index_sets/templates/built-in", null, { "warm_tier_enabled": warm_tier_enabled }, {
    "Accept": ["application/json"]
  });
}
export function getDefaultConfig() {
  return __request__("GET", "/system/indices/index_sets/templates/default_config", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getPage(sort = "title", page = 1, per_page = 50, query, filters, order = "asc") {
  return __request__("GET", "/system/indices/index_sets/templates/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function update(id, request) {
  return __request__("PUT", `/system/indices/index_sets/templates/${id}`, request, {}, {
    "Accept": ["application/json"]
  });
}
export function retrieveById(template_id) {
  return __request__("GET", `/system/indices/index_sets/templates/${template_id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(template_id) {
  return __request__("DELETE", `/system/indices/index_sets/templates/${template_id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
